module.exports = __webpack_public_path__ + "static/media/pic-6.ba052c34.jpg";